"use client";

import { useEffect } from "react";
import TagManager from "react-gtm-module";
import type { ProductsQuery } from "~/app/[lang]/(default)/category/[id]/ProductsGrid";
import { getProductImpressionData } from "~/lib/dataLayerData";

interface Props {
	products: ProductsQuery["items"];
	category?: string | null;
}

export function ProductListImpressions({ products, category }: Props) {
	useEffect(() => {
		TagManager.dataLayer({ dataLayer: { ecommerce: null } });
		TagManager.dataLayer({
			dataLayer: {
				event: "viewListing",
				ecommerce: {
					impressions: products.map((product, index) => ({
						...getProductImpressionData(product),
						list: "Categories",
						position: index + 1,
					})),
				},
			},
		});

		TagManager.dataLayer({
			dataLayer: {
				event: "view_item_list_ga4",
				ecommerce: {
					items: products.map((product, index) => ({
						// @ts-expect-error TODO: fix this
						...getProductImpressionData(product, true, category),
						index: index + 1,
					})),
				},
			},
		});
	}, [category, products]);

	return null;
}
